module.exports = __webpack_public_path__ + "static/img/avatar_r_6.e7313fd4.png";